/**
 * Converte um Blob para string Base64 (Data URL).
 *
 * @param blob - O Blob a ser convertido.
 * @returns Promise com a string Base64 no formato `data:mime;base64,...`.
 *
 * @example
 * ```typescript
 * const base64 = await blobToBase64(imageBlob);
 * ```
 */
function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

/**
 * Converte um arquivo (File) para string Base64 (Data URL).
 *
 * @param file - O arquivo a ser convertido.
 * @returns Promise com a string Base64 no formato `data:mime;base64,...`.
 *
 * @example
 * ```typescript
 * const base64 = await fileToBase64(selectedFile);
 * ```
 */
export function fileToBase64(file: File): Promise<string> {
  return blobToBase64(file);
}
